<template>
    <div>
        <page-header pageTitle="RESERVE.INDEX_TITLE" has-slot>
            <template #container>
                <div class="card p-2 mt-2  d-flex flex-row align-items-center header-toolbar-actions"
                     style="border-radius: 15px;">
                    <div class="toolbar-select mr-2" v-if="widthMd(938, '>')">
                            <span class="toolbar-select-label">
                                <i class="icon-grid"></i>
                                {{ t('NAV.ALLOTMENT_S') }}:
                            </span>
                        <div class="toolbar-select-control">
                            <select2 :settings="{ width: '100%', placeholder:  'Loteamentos'}"
                                     :options="allotments"
                                     v-model="allotmentId" @select="changeAllotment($event)"/>
                        </div>
                    </div>
                    <div class="align-self-center mr-2" v-if="this.$hasPermission('Reserve_create', true)">
                        <a class="btn btn-primary " id="filter" data-toggle="modal" data-target="#customModalTwo"
                           @click="setFilterModal">
                            Filtro
                        </a>
                    </div>
                    <div class="align-self-center" v-if="this.$hasPermission('Reserve_create', true)">
                        <a class="btn btn-custom bg-btn" data-toggle="modal" data-target="#customModalTwo"
                           @click="setRegisterModal" id="new" data-cy="btn-new-page-header">
                            <i class="icon-circle-with-plus"></i> Novo
                        </a>
                    </div>
                </div>
            </template>
        </page-header>
        <div class="card mb-1" v-if="subtitles">
            <div class="tags-block mb-1 ml-2 p-1 row left-content justify-content-between paddin">
                <div class="d-flex flex-row align-items-center flex-wrap">
                    <div class="tags" v-for="sub in subtitles" :key="sub.id">
                        <div class="mr-2">
                            <i class="icon-label" :style="{'color': sub.text_color}"></i> {{ sub.name }}
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 d-flex justify-content-end align-items-center"
                     v-if="this.$hasPermission('group_adm', true)">
                    <div class="mr-3 align-self-center">
                        <div id="import-buttom" style="font-size: 20px" data-toggle="dropdown" class="pointer">
                            <i class="icon-menu"/>
                        </div>
                        <div class="dropdown-menu dropdown-menu-right dropdown-black dropdown-lot w-auto"
                             id="dropdown-import">
                            <div class="dropdown-item bg-hover-black w-auto"
                                 v-if="this.$hasPermission('Reserve_getRealtors', true)">
                                <a class="row item-custom2 ml-1 text-white pr-2"
                                   @click="$router.push('/corretores/reservas')">
                                    <i class="icon-eye1 mr-1 font-15"/>
                                    {{ !widthMd(1000) ? t('LOTS.VIEW_REALTORS_RESERVES') : 'Reservas por Corretor' }}
                                </a>
                            </div>
                            <div class="dropdown-item bg-hover-black w-auto"
                                 v-if="this.$hasPermission('Reserve_index', true)">
                                <a class="row item-custom2 ml-1 text-white pr-2"
                                   @click="exportXLSXIndex">
                                    <i class="icon-download mr-1 font-15"/>
                                    Exportar em XLSX
                                </a>
                            </div>
                            <div class="dropdown-item bg-hover-black w-auto"
                                 v-if="this.$hasPermission('Reserve_index', true)">
                                <a class="row item-custom2 ml-1 text-white pr-2"
                                   @click="exportPDFIndex">
                                    <i class="icon-download mr-1 font-15"/>
                                    Exportar em PDF
                                </a>
                            </div>
                            <div class="dropdown-item bg-hover-black w-auto"
                                 v-if="this.$hasPermission('Reserve_allowCreate', true)">
                                <a class="row item-custom2 ml-1 text-white pr-2"
                                   data-target="#customModalTwo" data-toggle="modal"
                                   @click="setModalPlusTimeMax">
                                    <i class="icon-clock1 mr-1 font-15"/>
                                    Aumentar duração das reservas
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-1" v-if="hastwoAllotments && widthMd(939, '<')">
            <div class="card-header pl-3 pb-0 pt-2">
                <div class="card-title">
                    <label for="state">{{ t('NAV.ALLOTMENT') }}</label>
                </div>
            </div>
            <div class="card-body pl-3 pb-3 pt-0">
                <select2 :settings="{ width: widthMd(700) ? '100%' : '50%', placeholder:  'Todos'}"
                         :options="allotments"
                         v-model="allotmentId" @select="changeAllotment($event)"/>
            </div>
        </div>
        <div v-if="!widthPhone(575)">
            <div class="data-list-card card" v-if="(items && items.data)">
                <div class="data-list-card__header">
                    <span class="data-list-card__title">{{ t('RESERVE.INDEX_TITLE') }}</span>
                    <span class="data-list-card__count">{{ items.data.length }}</span>
                </div>
                <div class="data-list-card__body">
                    <div class="table-responsive">
                        <table class="table table-hover data-list-table mb-0">
                    <thead>
                    <tr>
                        <th class="text-center">
                            {{ t('RESERVE.STATUS') }}
                        </th>
                        <th class="text-center">
                            {{ t('RESERVE.REALTOR') }}
                        </th>
                        <th class="text-center">
                            {{ t('RESERVE.CLIENT') }}
                        </th>
                        <th class="text-center">
                            Propostas
                        </th>
                        <th class="text-center">
                            {{ t('RESERVE.ALLOTMENT') }}
                        </th>
                        <th class="text-center">Obs.
                        </th>
                        <th class="text-center">
                            {{ t('PROPERTIES.BLOCK') }}
                        </th>
                        <th class="text-center">
                            {{ t('PROPERTIES.NAME') }}
                        </th>
                        <th class="text-center">
                            {{ t('RESERVE.DURATION') }}
                        </th>
                        <th class="text-center">
                            {{ t('ACTIONS.LABEL') }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(iten, key) in items.data" :key="iten.id">
                        <td class="text-center pt-2 pb-2" :style="{color: iten.reserve_type.text_color}">
                            <span class="reserve-status-badge" :class="getReserveStatusBadgeClass(iten.reserve_status)">
                                {{ iten.reserve_status.name }}
                            </span>
                        </td>
                        <td class="pt-2 pb-2 data-list-table__muted-text" :style="{color: iten.reserve_type.text_color}">
                            {{ iten.realtor?.name }}
                        </td>
                        <td class="pt-2 pb-2 data-list-table__primary-text reserve-client-list" :style="{color: iten.reserve_type.text_color}"
                            :title="setClient(iten.reserves_clients)">
                            {{ setClient(iten.reserves_clients) }}
                        </td>
                        <td class="text-center pt-2 pb-2 reserve-proposals-cell">
                            <span class="reserve-proposals-wrapper"
                                  @mouseenter="showProposalHistory(iten, $event)"
                                  @mouseleave="hideProposalHistory">
                                <button type="button"
                                        class="reserve-proposals-trigger"
                                        :class="{'reserve-proposals-trigger--empty': !iten.qtd_proposal}">
                                    {{ iten.qtd_proposal || 0 }}
                                </button>

                                <teleport to="body">
                                    <div v-if="activeProposalHistoryId === iten.id"
                                         class="reserve-proposals-popover"
                                         :class="{'reserve-proposals-popover--top': activeProposalHistoryPlacement === 'top'}"
                                         :style="activeProposalHistoryStyle"
                                         @mouseenter="cancelHideProposalHistory"
                                         @mouseleave="hideProposalHistory">
                                        <div class="reserve-proposals-popover__header">
                                            <div>
                                                <strong>Histórico de propostas</strong>
                                                <small>{{ iten.qtd_proposal }} encontrada(s)</small>
                                            </div>
                                            <span class="reserve-proposals-popover__badge">Reserva</span>
                                        </div>
                                        <div v-if="iten.qtd_proposal" class="reserve-proposals-popover__body">
                                            <div class="reserve-proposals-loading" v-if="iten.proposalsLoading || !iten.proposals">
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                      aria-hidden="true"></span>
                                                <span>Carregando propostas...</span>
                                            </div>
                                            <div v-else class="reserve-proposals-list">
                                                <div class="reserve-proposal-card" v-for="proposal in iten.proposals"
                                                     :key="proposal.id">
                                                    <div class="reserve-proposal-card__top">
                                                        <span class="reserve-proposal-card__number">#{{ getNumberProposal(proposal) }}</span>
                                                        <span class="reserve-proposal-card__status ">
                                                        <div class="font-weight-bold align-self-center d-flex w-100 justify-content-center"
                                                             style="margin-bottom: -2px; width: 110px; text-align: justify"
                                                             id="status">
                                                                 <span class="rounded-pill pb-1 pt-1 text-center card pl-2 pr-2 dynamic-background-card dynamic-text-color"
                                                                 :style="{'--dynamic-bg': translateColorStatus(proposal.status), '--dynamic-color': 'white'}">
                                                                 {{ this.translateStatus(proposal.status) }}
                                                             </span>
                                                         </div>
                                                        </span>
                                                    </div>
                                                    <div class="reserve-proposal-card__info">
                                                        <div class="reserve-proposal-card__detail">
                                                            <span class="reserve-proposal-card__label">Assinatura</span>
                                                            <strong>{{ getStatusClickSing(proposal?.click_sign_documents?.status) }}</strong>
                                                        </div>
                                                        <div class="reserve-proposal-card__detail">
                                                            <span class="reserve-proposal-card__label">Criação</span>
                                                            <strong>{{ createdDateProposal(proposal.created_at) }}</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="reserve-proposals-empty">
                                            Nenhuma proposta vinculada
                                        </div>
                                    </div>
                                </teleport>
                            </span>
                        </td>
                        <td class="text-center pt-2 pb-2" :style="{color: iten.reserve_type.text_color}"
                            v-if="!widthPhone()">
                            {{
                                iten?.properties?.allotments?.name ? iten?.properties?.allotments?.name : 'Indefinido'
                            }}
                        </td>
                        <td class="text-center pt-2 pb-2" :style="{color: iten.reserve_type.text_color}">
                     <span id="dropInfo" class="mr-2">
                              <span class="dropdown" @mouseout="setModalHoover(`dropdownMenu${key}`)"
                                    @mouseover="setModalHoover(`dropdownMenu${key}`)">
                                 <i class="icon-info-with-circle ml-1"
                                    :id="`dropdownMenu${key}`"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"></i>
                                 <div class="dropdown-menu p-2" :aria-labelledby="`dropdownMenu${key}`"
                                      style="min-width: 30rem;">
                                    <div class="mb-2 p-2">
                                         <div class="form-group">
                                          <label for="exampleFormControlTextarea1">Observações:</label>
                                           <p id="exampleFormControlTextarea1"
                                              style="font-size: 13px"
                                              disabled
                                           >{{ iten.observation ? iten.observation : ' ' }}</p>
                                          </div>
                                    </div>
                                 </div>
                              </span>
                     </span>
                        </td>
                        <td class="text-center pt-2 pb-2" :style="{color: iten.reserve_type.text_color}">
                            <span class="data-list-table__badge reserve-property-badge">{{ iten.properties.block }}</span>
                        </td>
                        <td class="text-center pt-2 pb-2" :style="{color: iten.reserve_type.text_color}">
                            <span class="data-list-table__badge reserve-property-badge">{{ iten.properties.name }}</span>
                        </td>
                        <td class="text-center pt-2 pb-2" :style="{color: iten.reserve_type.text_color}">
                            {{ iten.reserveCooldown }}
                        </td>
                        <td class="text-center pt-2 pb-2">
                            <label class="mb-2" v-if="widthPhone()" :style="{color: iten.reserve_type.text_color}">
                                <b>{{ t('ACTIONS.LABEL') }}</b>
                            </label>
                            <div>
                                <a data-cy="reserve_index_confirm" class="mr-2 size green"
                                   :title="t('RESERVE.CONFIRM_RESERVATION')"
                                   v-if="this.$hasPermission('Reserve_confirm', true) && iten.reserve_status.type == 0"
                                   data-target="#customModalTwo" data-toggle="modal">
                                    <i class="icon-thumbs-up pointer" style="color: #197b19 !important;"
                                       @click="setConfirmModal(iten, iten.realtor?.name)"/>
                                </a>
                                <a data-cy="reserve_index_revoke" class="mr-1 size-red red"
                                   :title="t('RESERVE.DROP_RESERVATION')" data-target="#modalShow"
                                   data-toggle="modal"
                                   v-if="this.$hasPermission('Reserve_revoke', true) && (iten.reserve_status.type == 0)">
                                    <i class="icon-thumbs-down pointer" style="color: red !important;"
                                       @click="setDropModal(iten, iten.realtor?.name)"/>
                                </a>
                                <a type="button" data-toggle="dropdown" aria-haspopup="true"
                                   aria-expanded="false" class="data-list-table__action-badge">
                                    <i class="icon-more_horiz"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right dropdown-black w-auto">
                                    <div data-cy="reserve_index_renew"
                                         @click="renew(iten.id, iten.properties.allotment_id)"
                                         v-if="this.$hasPermission('Reserve_renew', true) && iten.reserve_status.type == 0"
                                         class="dropdown-item pointer text-white">
                                        {{ t('ACTIONS.RENEW') }}
                                    </div>
                                    <div data-cy="reserve_index_renew"
                                         @click="setEditModal(iten, iten.realtor?.name)"
                                         data-target="#customModalTwo" data-toggle="modal"
                                         v-if="this.$hasPermission('Reserve_update', true) && iten.reserve_status.type == 0"
                                         class="dropdown-item pointer text-white">
                                        {{ t('ACTIONS.EDIT') }}
                                    </div>
                                    <div class="dropdown-item pointer text-white"
                                         data-toggle="modal" data-target="#customModalTwo"
                                         v-if="iten?.reserves_clients?.length"
                                         @click="setModalClientAnexView(iten)">
                                        {{ t('PROPOSAL.CLIENT_FICH') }}
                                    </div>
                                    <div data-cy="reserve_index_change_time"
                                         @click="undetermined(iten.id, iten.properties.allotment_id)"
                                         v-if="this.$hasPermission('Reserve_undetermined', true) && iten.reserve_status.type == 0"
                                         class="dropdown-item pointer text-white">
                                        {{ t('ACTIONS.CHANGE_TIME') }}
                                    </div>
                                    <div data-cy="reserve_index_historic" data-target="#modalShow"
                                         data-toggle="modal"
                                         @click="setHistoricModal(iten, iten.realtor?.name)"
                                         v-if="this.$hasPermission('Reserve_historic', true)"
                                         class="dropdown-item pointer text-white">
                                        {{ t('ACTIONS.INFO') }} da reserva
                                    </div>
                                    <div data-cy="reserve_index_historic" data-target="#customModalTwo"
                                         data-toggle="modal"
                                         @click="this.$hasPermission('proposal_index', true) && setProposalModal(iten)"
                                         v-if="iten.hasProposal" class="dropdown-item pointer text-white">
                                        {{ t('PROPOSAL.PROPOSALS') }}
                                    </div>
                                    <div data-cy="reserve_index_historic" data-target="#customModalTwo"
                                         data-toggle="modal"
                                         v-if="this.$hasPermission('proposal_create', true) && iten.reserve_status.type == 0"
                                         @click="setSimulateModal(iten)"
                                         class="dropdown-item pointer text-white">
                                        {{ t('PROPOSAL.CREATE') }}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div v-if="items && items.data && !items.data[0] || items && items.validations">
                <div class="card">
                    <div class="card-header text-center">
                        {{ t('RESERVE.MSG.NONE_RECORD_FIND') }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="widthPhone(575)">
            <div v-if="(items && items.data)">
                <div class="card" v-for="(iten) in items.data" :key="iten.id">
                    <div class="pd-top-left-right pdt-1 aling justify-content-between">
                        <div :style="{color: iten.reserve_type.text_color}">
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('RESERVE.STATUS') }}</b></label>
                                <div>
                                    <span class="reserve-status-badge" :class="getReserveStatusBadgeClass(iten.reserve_status)">
                                        {{ iten.reserve_status.name }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" :style="{color: iten.reserve_type.text_color}">
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('PROPERTIES.BLOCK') }}</b></label>
                                <div>{{ iten.properties.block }}</div>
                            </div>
                        </div>
                        <div class="text-center" :style="{color: iten.reserve_type.text_color}">
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('PROPERTIES.NAME') }}</b></label>
                                <div>{{ iten.properties.name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="pd-top-left-right aling justify-content-between">
                        <div :style="{color: iten.reserve_type.text_color}">
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('RESERVE.REALTOR') }}</b></label>
                                <div>{{ iten.realtor?.name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="pd-top-left-right aling justify-content-between">
                        <div :style="{color: iten.reserve_type.text_color}">
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('RESERVE.CLIENT') }}</b></label>
                                <div>{{ setClient(iten.reserves_clients) }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="pd-top-left-right aling justify-content-between">
                        <div :style="{color: iten.reserve_type.text_color}">
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('RESERVE.DURATION') }}</b></label>
                                <div>{{ iten.reserveCooldown }}</div>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="form-group">
                                <label class="mb-2"
                                       :style="{color: iten.reserve_type.text_color}"><b>{{
                                        t('ACTIONS.LABEL')
                                    }}</b></label>
                                <div>
                                    <a data-cy="reserve_index_confirm" class="mr-2 size green"
                                       :title="t('RESERVE.CONFIRM_RESERVATION')"
                                       v-if="this.$hasPermission('Reserve_confirm', true) && iten.reserve_status.type == 0"
                                       data-target="#customModalTwo" data-toggle="modal">
                                        <i class="icon-thumbs-up pointer"
                                           @click="setConfirmModal(iten, iten.realtor?.name)"
                                           style="font-size: 23px; color: #197b19 !important;"/>
                                    </a>
                                    <a data-cy="reserve_index_revoke" class="mr-1 size-red red"
                                       :title="t('RESERVE.DROP_RESERVATION')" data-target="#modalShow"
                                       data-toggle="modal"
                                       v-if="this.$hasPermission('Reserve_revoke', true) && (iten.reserve_status.type == 0)">
                                        <i class="icon-thumbs-down pointer" style="color: red !important;"
                                           @click="setDropModal(iten, iten.realtor?.name)"/>
                                    </a>
                                    <a type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                       style="font-size: 24px">
                                        <i class="icon-more_horiz"></i>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right dropdown-black dropdown-reserve">
                                        <div data-cy="reserve_index_renew"
                                             @click="renew(iten.id, iten.properties.allotment_id)"
                                             v-if="this.$hasPermission('Reserve_renew', true) && iten.reserve_status.type == 0"
                                             class="dropdown-item pointer text-white">
                                            {{ t('ACTIONS.RENEW') }}
                                        </div>
                                        <div data-cy="reserve_index_renew"
                                             @click="setEditModal(iten, iten.realtor?.name)"
                                             data-target="#customModalTwo" data-toggle="modal"
                                             v-if="this.$hasPermission('Reserve_update', true) && iten.reserve_status.type == 0"
                                             class="dropdown-item pointer text-white">
                                            {{ t('ACTIONS.EDIT') }}
                                        </div>
                                        <div data-cy="reserve_index_change_time"
                                             @click="undetermined(iten.id, iten.properties.allotment_id)"
                                             v-if="this.$hasPermission('Reserve_undetermined', true) && iten.reserve_status.type == 0"
                                             class="dropdown-item pointer text-white">
                                            {{ t('ACTIONS.CHANGE_TIME') }}
                                        </div>
                                        <div data-cy="reserve_index_historic" data-target="#modalShow"
                                             data-toggle="modal" @click="setHistoricModal(iten, iten.realtor?.name)"
                                             v-if="this.$hasPermission('Reserve_historic', true)"
                                             class="dropdown-item pointer text-white">
                                            {{ t('ACTIONS.INFO') }} da reserva
                                        </div>
                                        <div data-cy="reserve_index_historic" data-target="#customModalTwo"
                                             data-toggle="modal"
                                             @click="setProposalModal(iten)"
                                             v-if="this.$hasPermission('proposal_index', true) && iten.hasProposal"
                                             class="dropdown-item pointer text-white">
                                            {{ t('PROPOSAL.PROPOSALS') }}
                                        </div>
                                        <div data-cy="reserve_index_historic" data-target="#customModalTwo"
                                             data-toggle="modal"
                                             v-if="this.$hasPermission('proposal_create', true) && iten.reserve_status.type == 0"
                                             @click="setSimulateModal(iten)"
                                             class="dropdown-item pointer text-white">
                                            {{ t('PROPOSAL.CREATE') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row gutters mt-2">
            <div class="col-12">
                <pagination-component v-if="items && items.data && items.data[0]" :items="items" :to="'/reserva'"
                                      :have-per-page="!widthMd(1000)"
                                      :per-page="perPage"
                                      :paginate="paginate"
                                      @changePage="indexReserve(allotmentId, $event, true)"
                                      @changePaginate="changePaginate"></pagination-component>
            </div>
        </div>
        <modal :modal-extra-large="wichModal === 7 || wichModal === 2 || wichModal === 6"
               :modal-xl="wichModal !== 7 && wichModal !== 2 && wichModal !== 6" :titleModal="modalTitle"
               @close="closeModal()" v-if="wichModal !== 5">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <create-reserve v-if="reserve && wichModal === 1" :reserveIndex="reserve" :allotmentsIndex="allotments"
                            :blocksIndex="blocksIndex" :reserveTypesIndex="reserveTypesIndex"
                            :is-data-required="isDataRequired"
                            :is-email-required="isEmailRequired"
                            :isRealtor="this.$hasPermission('group_broker', true)" @created="updateAfterCreated"
                            @close="reloadIndex">
            </create-reserve>
            <confirm-reserve v-if="reserveIndex && wichModal === 2"
                             :reserveIndex="reserveIndex"
                             :modalTitle="modalTitle"
                             :is-data-required="isDataRequired"
                             :is-email-required="isEmailRequired"
                             @close="this.indexAllotment()"
                             :isConfirm="isConfirm" @confirm="updateAfter">
            </confirm-reserve>
            <edit-reserve-component v-if="reserveIndex && wichModal === 8"
                                    :reserveIndex="reserveIndex"
                                    :modalTitle="modalTitle"
                                    :is-data-required="isDataRequired"
                                    :is-email-required="isEmailRequired"
                                    :isConfirm="isConfirm" @confirm="updateAfter"
            ></edit-reserve-component>
            <modal-plus-time-reserve v-if="wichModal === 10"></modal-plus-time-reserve>
            <proposal-list-by-reserve-component
                    :reserveIndex="reserveIndex"
                    :modalTitle="modalTitle"
                    v-if="wichModal === 6"/>
            <iframe style="height: 80vh!important;"
                    :allow="`clipboard-read ${hostSimulator}; clipboard-write ${hostSimulator}`"
                    :src="srcIframe"
                    sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-clipboard-read allow-clipboard-write"
                    v-if="wichModal === 7 && srcIframe"/>
            <listPersonDownloadFich v-if="wichModal === 9" :clients="clientsForFich"></listPersonDownloadFich>
            <div class="modal-footer right-content" v-if="wichModal === 7">
                <button data-cy="lot_index_simulate_close" @click="closeModalProposal" class="btn btn-secondary"
                        data-dismiss="modal" type="button">
                    {{ t('ACTIONS.CLOSE') }}
                </button>
            </div>
        </modal>
        <modal :titleModal="modalTitle" :modal-xl="true" v-if="wichModal === 5">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <filter-reserve v-if="wichModal === 5" :blocksIndex="blocks" :statusIndex="status" :clientsIndex="clients"
                            :realtorsIndex="realtors" :allotmentId="allotmentId"
                            :lotsIndex="lots"
                            :perPageIndex="perPage"
                            @search="updateAfterSearch"
                            @closeClear="closeFilter()"
            ></filter-reserve>
        </modal>
        <modals-reserve v-if="reserveIndex && (wichModal === 3 || wichModal === 4)" :reserveIndex="reserveIndex"
                        :modalTitle="modalTitle" @drop="updateAfter" :wichModal="wichModal">
        </modals-reserve>
        <modal-select-allotment v-if="allotments" :showModal="showModalAllotment"
                                scope-allotment @showModal="showModalAllotment = $event"
                                @allotmentSelected="allotmentModalSelect">
        </modal-select-allotment>
    </div>
</template>

<script>

import {mapState} from 'vuex';
import {useI18n} from 'vue-i18n';
import User from '@/services/user';
import Lots from '@/services/Lots';
import Modal from '@/components/modal';
import Reserve from '@/services/Reserves';
import widthMd from '../../mixins/widthMd';
import {useToast} from 'vue-toastification';
import Select2 from 'vue3-select2-component';
import Validate from '@/components/validate.vue';
import ReserveTypes from '@/services/ReserveTypes';
import Allotments from '../../services/Allotments';
import ReserveStatus from '@/services/ReserveStatus';
import createReserve from './createReserveComponent';
import pageHeader from '@/components/layouts/pageHeader';
import modalsReserve from './modalsReserveComponent.vue';
import filterReserve from './filterReserveComponent.vue';
import editReserveComponent from './editReserveComponent';
import confirmReserve from './confirmReserveComponent.vue';
import BuildSimulatorUrl from '@/Helpers/BuildSimulatorUrl';
import PaginationComponent from '@/components/layouts/PaginationComponent';
import proposalListByReserveComponent from './proposalListByReserveComponent';
import modalSelectAllotment from '../allotment/modalSelectAllotmentComponent.vue';
import {PDFDocument} from 'pdf-lib';
import Clients from '@/services/Clients';
import listPersonDownloadFich from '@/pages/proposal/listPersonDownloadFich';
import modalPlusTimeReserve from './modalPlusTimeReserve';
import UserCompanies from '../../services/UserCompanies';
import StatusProposal from '../../mixins/StatusProposal';

export default {
    name: 'IndexReserve',
    mixins: [Validate, widthMd, BuildSimulatorUrl, StatusProposal],
    components: {
        Modal,
        Select2,
        pageHeader,
        filterReserve,
        createReserve,
        modalsReserve,
        confirmReserve,
        PaginationComponent,
        editReserveComponent,
        modalSelectAllotment,
        proposalListByReserveComponent,
        listPersonDownloadFich,
        modalPlusTimeReserve,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },
    computed: {
        ...mapState({
            paginate: 'paginate',
            allotments: 'allotments',
            allotmentLoad: 'allotmentLoad',
            reserveCooldown: 'reserveCooldown',
            hastwoAllotments: 'hastwoAllotments',
        }),
        hostSimulator() {
            return process.env.VUE_APP_SIMULATOR_HOST;
        },
    },
    data() {
        return {
            clientsForFich: [],
            lots: {},
            blocks: [],
            lotSort: 0,
            items: null,
            clients: [],
            status: null,
            reserve: null,
            perPage: null,
            realtors: null,
            modalTitle: '',
            srcIframe: null,
            loopReserve: [],
            wichModal: null,
            durationSort: 0,
            subtitles: null,
            isConfirm: false,
            howSorting: null,
            realtorIndex: [],
            isHistoric: false,
            blocksIndex: null,
            allotmentId: null,
            reserveIndex: null,
            isDataRequired: null,
            isEmailRequired: null,
            activeProposalHistoryId: null,
            activeProposalHistoryStyle: {},
            activeProposalHistoryPlacement: 'bottom',
            proposalHistoryHideTimeout: null,
            reserveTypesIndex: null,
            showModalAllotment: false,
            showAllotmentSelect: false,
            filter: {
                block: null,
                clientId: null,
                realtorId: null,
                reserveStatusType: null,
                lots: null,
            },
        };
    },
    async mounted() {
        if (this.allotmentLoad) {
            await this.indexMounted();
        }
    },
    watch: {
        allotments: async function () {
            if (!sessionStorage.getItem('allotmentIdScope')) {
                this.showModalAllotment = true;
            }
        },
        async allotmentLoad(newValue) {
            if (newValue) {
                await this.indexMounted();
            }
        }
    },
    methods: {
        getReserveStatusBadgeClass(status) {
            const normalizedName = (status?.name || '')
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase();

            if (normalizedName.includes('venda cancelada')) return 'reserve-status-badge--sale-canceled';
            if (normalizedName.includes('progresso')) return 'reserve-status-badge--progress';
            if (normalizedName.includes('cancelada') || normalizedName.includes('cancelado')) return 'reserve-status-badge--canceled';
            if (normalizedName.includes('interrompido') || normalizedName.includes('interrompida')) return 'reserve-status-badge--interrupted';
            if (normalizedName.includes('confirmado') || normalizedName.includes('confirmada')) return 'reserve-status-badge--confirmed';
            if (normalizedName.includes('expirado') || normalizedName.includes('expirada')) return 'reserve-status-badge--expired';

            return 'reserve-status-badge--default';
        },
        getNumberProposal(iten) {
            let block = '';
            if (iten.properties?.block) {
                block = iten.properties.block.replace(/^0+/, '');
            }
            let lot = '';
            if (iten.properties?.name) {
                lot = iten.properties.name.replace(/^0+/, '');
            }
            if (iten.created_at) {
                let date = iten.created_at?.split('T');
                date = date[1]?.split(':');
                let sec = date[2]?.split('.')
                return `${block}${lot}${date[0]}${date[1]}${sec[0]}`;
            }
            return `${block}${lot}`;
        },
        async indexMounted() {
            if (sessionStorage.getItem('allotmentIdScope')) {
                this.allotmentId = sessionStorage.getItem('allotmentIdScope');
                this.$store.commit('changeLoading', true);
                await this.chanceCustomScope(this.allotmentId);
                await this.indexAllotment();
                this.indexReserveType();
                await this.startAfterReseve();
            } else if (this.allotments?.length === 1) {
                this.allotmentId = this.allotments.find(i => i.id).id;
                sessionStorage.setItem('allotmentIdScope', this.allotmentId);
                this.$store.commit('changeLoading', true);
                await this.chanceCustomScope(this.allotmentId);
                await this.indexAllotment();
                this.indexReserveType();
                await this.startAfterReseve();
            } else {
                this.showModalAllotment = true;
            }
        },
        async chanceCustomScope(id) {
            await UserCompanies.chanceCustomScope(id).then(async resp => {
                await this.$setCustomToken(resp.data.accessToken, resp.data.refreshToken);
                this.wichModal = null;
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        setModalPlusTimeMax() {
            this.wichModal = 10;
            this.modalTitle = 'Aumentar duração das reservas';
        },
        async setModalClientAnexView(iten) {
            if (iten.reserves_clients.length === 1) {
                await this.printClientPdf(iten.reserves_clients?.find(i => i).clients);
                document.getElementById('closeX')?.click();
            } else {
                this.wichModal = 9;
                this.modalTitle = 'Download ficha do cliente';
                this.clientsForFich = iten.reserves_clients;
            }
        },
        async printClientPdf(iten) {
            this.$store.commit('changeLoading', true);
            await Clients.exportPdfClient(iten.id).then(async (response) => {
                if (response.data?.length) {
                    const mergedPdf = await PDFDocument.create();
                    for (const pdfObj of response.data) {
                        if (pdfObj?.basefile) {
                            const pdfBase64 = pdfObj.basefile;
                            const pdfBytes = this.base64ToUint8Array(pdfBase64);
                            try {
                                const pdfDoc = await PDFDocument.load(pdfBytes);
                                const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                copiedPages.forEach((page) => mergedPdf.addPage(page));
                            } catch (err) {
                                const blob = new Blob([pdfBytes], {type: 'application/pdf'});
                                const url = URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                let fileName = response.data.find(i => i)?.name ? response.data.find(i => i)?.name : 'arquivoPessoas.pdf';
                                fileName = fileName?.replaceAll('.pdf', '');
                                fileName = fileName + (pdfObj?.name ? pdfObj?.name : '.pdf');
                                a.download = fileName;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                URL.revokeObjectURL(url);
                            }
                        }
                    }
                    const mergedPdfFile = await mergedPdf.save();
                    const blob = new Blob([mergedPdfFile], {type: 'application/pdf'});
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    let fileName = response.data.find(i => i)?.name ? response.data.find(i => i)?.name : 'arquivoPessoas.pdf'
                    a.href = url;
                    a.download = fileName;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            })
        },
        base64ToUint8Array(base64) {
            const base64Data = base64.replace(/^data:application\/pdf;base64,/, '');
            const binaryString = window.atob(base64Data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes;
        },
        exportXLSXIndex() {
            this.$store.commit('changeLoading', true);
            Reserve.index(this.filter, this.allotmentId, 1, this.perPage, 'xls').then(response => {
                if (!response?.data?.validations && response.data) {
                    const blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'exportar_reservas.xls';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error);
            });
        },
        exportPDFIndex() {
            this.$store.commit('changeLoading', true);
            Reserve.index(this.filter, this.allotmentId, 1, this.perPage, 'pdf').then(resp => {
                if (!resp?.data?.validations && resp.data) {
                    const link = document.createElement('a');
                    link.href = resp.data;
                    link.download = 'exportar_reservas.pdf';
                    document.body.appendChild(link);
                    link.click();
                }
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error);
            });
        },
        changePaginate(perPage) {
            this.perPage = perPage;
            this.indexReserve();
        },
        setModalHoover(id) {
            document.getElementById(id).click();
        },
        async setSimulateModal(reserve) {
            if (!reserve?.reserves_clients?.length) {
                setTimeout(() => document.getElementById('closeX')?.click(), 500);
                this.$store.commit('changeLoading', true);
                this.toast.error('Não é possivel gerar proposta para reserva que não possui clientes vinculados');
                return;
            }
            this.wichModal = 7;
            this.modalTitle = 'LOTS.CREATE_PROPOSE';
            const {properties} = reserve;
            await this.buildSimulatorUrl(properties.id, localStorage.getItem('companyId'))
                    .then(url => this.srcIframe = url)
                    .catch(err => this.errorMsg(err));
        },
        toCurrency(value) {
            if (value === null) return 'Indisponível';
            return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(value);
        },
        base64_encode(string) {
            return btoa(unescape(encodeURIComponent(string)));
        },
        createdDateProposal(value) {
            let dateAndTime = value.split('T');
            let date = dateAndTime[0].split('-');
            let time = dateAndTime[1].split(':');
            return `${date[2]}/${date[1]}/${date[0]} ${time[0]}:${time[1]}`;
        },
        setProposalModal(iten) {
            this.wichModal = 6;
            this.$store.commit('changeLoading', true);
            Reserve.showProposals(iten.id, true).then(resp => {
                this.reserveIndex = resp.data;
                this.$store.commit('changeLoading', false);
                this.modalTitle = 'PROPOSAL.PROPOSALS';
                this.wichModal = 6;
            }).catch(() => this.$store.commit('changeLoading', false));
        },
        async getLots() {
            await Lots.getLotsByAllotment(this.allotmentId).then(resp => this.lots = resp.data);
        },
        closeFilter() {
            this.filter = {
                block: null,
                clientId: null,
                realtorId: null,
                reserveStatusType: null,
                lots: null,
            };
            this.wichModal = null;
            this.filter.reserveStatusType = '0';
            this.indexReserve();
        },
        async indexReserve(allotment_id = this.allotmentId, page = 1, paginate = null) {
            this.$store.commit('changeLoading', true);
            if (paginate) {
                this.loopReserve.forEach(item => clearInterval(item));
            }
            await Reserve.index(this.filter, allotment_id, page, this.perPage).then(resp => {
                this.items = resp.data;
                this.startAfterReseve(resp.data?.data);
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error);
            });
        },
        indexBlocks(allotment_id) {
            Lots.blocksListAvailable(allotment_id).then(async resp => {
                if (!resp.data?.validations) {
                    await (this.blocks = resp.data);
                }
            }).catch(error => this.errorMsg(error));
        },
        async indexRealtor(allotment_id) {
            await User.listRealtor(allotment_id).then(resp => {
                if (!resp.data.validations) {
                    this.realtors = resp.data;
                    this.realtors.unshift({id: 0, text: this.t('GENERAL.NONE')});
                } else this.realtors = null;
            }).catch(error => this.errorMsg(error));
        },
        indexClients(reseves) {
            reseves.reserves_clients.forEach(reserveClients => {
                if (reserveClients.clients) {
                    if (!this.clients.find(client => client.id == reserveClients.clients?.id)) {
                        this.clients.push({id: reserveClients.clients?.id, text: reserveClients.clients?.name});
                    }
                }
            });
            if (!this.clients.find(c => c.id == 0)) {
                this.clients.unshift({id: 0, text: this.t('GENERAL.NONE')});
            }
        },
        indexStatus() {
            ReserveStatus.list().then(resp => {
                if (!resp.data?.validations) {
                    this.status = resp.data;
                    this.status.unshift({id: 99, text: this.t('GENERAL.NONE')});
                }
            }).catch(error => this.errorMsg(error))
                    .finally(() => this.$store.commit('changeLoading', false));
        },
        async indexAllotment() {
            if (this.wichModal == 1) return;
            this.showAllotmentSelect = this.hastwoAllotments == true && (sessionStorage.getItem('allotmentIdScope') ? false : true);
            this.isLoading = this.showAllotmentSelect ? false : true;
            if (this.allotmentLoad) {
                if (this.hastwoAllotments == false) {
                    this.allotmentId = this.allotments[0]?.id;
                } else {
                    this.allotmentId = sessionStorage.getItem('allotmentIdScope');
                }
                await this.startReserve(this.allotmentId);
            }
        },
        indexReserveType() {
            ReserveTypes.listToLabel()
                    .then(resp => this.subtitles = resp.data)
                    .catch(error => this.errorMsg(error));
        },
        allotmentSelected() {
            this.$store.commit('changeLoading', true);
            this.allotmentId = sessionStorage.getItem('allotmentIdScope');
            this.startReserve(this.allotmentId);
        },
        async changeAllotment({id}) {
            this.$store.commit('changeLoading', true);
            this.isDataRequired = null;
            this.isEmailRequired = null;
            this.loopReserve.forEach(loop => clearInterval(loop));
            sessionStorage.setItem('allotmentIdScope', id);
            this.allotmentId = id;
            await this.chanceCustomScope(this.allotmentId);
            this.startReserve(id);
        },
        async startReserve(allotment_id, reloadF = true) {
            if (reloadF) {
                this.filter.reserveStatusType = '0';
            }
            await this.indexReserve(allotment_id);
        },
        closeModalProposal() {
            document.getElementById('closeX').click();
            this.reloadIndex();
        },
        closeModal() {
            if (this.wichModal === 8) {
                this.wichModal = null;
                this.isDataRequired = null;
                this.isEmailRequired = null;
            } else {
                this.reloadIndex(false);
            }
        },
        async reloadIndex(reloadF = true) {
            this.wichModal = null;
            this.isDataRequired = null;
            this.isEmailRequired = null;
            this.loopReserve.forEach(loop => clearInterval(loop));
            await this.startReserve(this.allotmentId, reloadF);
        },
        async allotmentModalSelect() {
            this.allotmentId = sessionStorage.getItem('allotmentIdScope');
            await this.chanceCustomScope(this.allotmentId);
            this.startReserve(this.allotmentId);
        },
        setRegisterModal() {
            this.wichModal = 1;
            this.$store.commit('changeLoading', true);
            this.isEmailRequired = null;
            this.isDataRequired = null;
            Reserve.verifyLimitReserve(this.allotmentId).then(() => {
                this.wichModal = 1;
                this.reserve = {
                    blocks: [],
                    clients: [],
                    realtors: [],
                    observation: '',
                    isLotOrigin: false,
                    reserve_type_id: null,
                    allotments: this.allotments,
                    allotment_id: this.allotmentId,
                };
                this.modalTitle = 'RESERVE.MODAL_TITLE.ADD';
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
            Allotments.show(this.allotmentId).then(resp => {
                this.isDataRequired = resp.data.is_required_data_client;
                this.isEmailRequired = resp.data.is_required_email;
            });
        },
        updateAfterCreated() {
            this.indexReserve(this.allotmentId);
        },
        setClient(clients) {
            let client;
            clients.forEach((element, key) => {
                if (element.clients) {
                    client = key === 0 ? element.clients?.name : client + ', ' + element.clients?.name;
                }
            });
            if (typeof client == 'undefined') client = this.t('GENERAL.MSG.NONE_COSTUMER_LIKED');
            return client;
        },
        showProposalHistory(iten, event) {
            this.cancelHideProposalHistory();
            this.setProposalHistoryPosition(event.currentTarget);
            this.activeProposalHistoryId = iten.id;
            if (iten.qtd_proposal && !iten.proposals && !iten.proposalsLoading) {
                iten.proposalsLoading = true;
                Reserve.showProposals(iten.id, true).then(resp => {
                    iten.proposals = resp.data.business_proposal;
                }).finally(() => iten.proposalsLoading = false);
            }
        },
        setProposalHistoryPosition(target) {
            const rect = target.getBoundingClientRect();
            const margin = 12;
            const gap = 10;
            const popoverWidth = Math.min(430, window.innerWidth - (margin * 2));
            const availableBelow = window.innerHeight - rect.bottom - margin;
            const availableAbove = rect.top - margin;
            const left = Math.min(
                    Math.max(rect.left + (rect.width / 2), margin + (popoverWidth / 2)),
                    window.innerWidth - margin - (popoverWidth / 2)
            );
            const shouldOpenTop = availableBelow < 260 && availableAbove > availableBelow;
            const availableHeight = shouldOpenTop ? availableAbove : availableBelow;
            const listMaxHeight = Math.max(130, Math.min(320, availableHeight - gap - 72));
            const popoverHeight = listMaxHeight + 72;
            const top = shouldOpenTop
                    ? Math.max(margin, rect.top - popoverHeight - gap)
                    : rect.bottom + gap;

            this.activeProposalHistoryPlacement = shouldOpenTop ? 'top' : 'bottom';
            this.activeProposalHistoryStyle = {
                left: `${left}px`,
                top: `${top}px`,
                width: `${popoverWidth}px`,
                '--reserve-proposals-list-max-height': `${listMaxHeight}px`,
            };
        },
        hideProposalHistory() {
            this.proposalHistoryHideTimeout = setTimeout(() => {
                this.activeProposalHistoryId = null;
            }, 45);
        },
        cancelHideProposalHistory() {
            if (this.proposalHistoryHideTimeout) {
                clearTimeout(this.proposalHistoryHideTimeout);
                this.proposalHistoryHideTimeout = null;
            }
        },

        indexDuration(iten, key) {
            if (iten.permanences_active[0] && iten.permanences_active[0].finish) {
                let finish = iten.permanences_active[0].finish;
                const time = new Date();
                const timeFinish = new Date(finish);
                if (timeFinish < time) {
                    this.items.data[key].reserveCooldown = '00:00';
                } else {
                    let cooldown = (timeFinish.getTime() - time.getTime()) / 1000;
                    let hours = parseInt(cooldown / 3600);
                    cooldown = cooldown % 3600;
                    let minutes = parseInt(cooldown / 60);
                    let seconds = parseInt(cooldown % 60);
                    let hoursToShow = hours < 10 ? '0' + hours : hours;
                    let minutesToShow = minutes < 10 ? '0' + minutes : minutes;
                    let secondsToShow = seconds < 10 ? '0' + seconds : seconds;
                    this.items.data[key].reserveCooldown = hoursToShow + ':' + minutesToShow + ':' + secondsToShow;
                    this.loopReserve.push(setInterval(() => {
                        if (seconds == 0 && minutes == 0 && hours == 0) {
                            clearInterval(this.loopReserve[key]);
                            this.items.data[key].reserveCooldown = '00:00';
                        } else {
                            let timeNow = new Date();
                            let cooldown = (timeFinish.getTime() - timeNow.getTime()) / 1000;
                            hours = parseInt(cooldown / 3600);
                            cooldown = cooldown % 3600;
                            minutes = parseInt(cooldown / 60);
                            seconds = parseInt(cooldown % 60);
                            hoursToShow = hours < 10 ? '0' + hours : hours;
                            minutesToShow = minutes < 10 ? '0' + minutes : minutes;
                            secondsToShow = seconds < 10 ? '0' + seconds : seconds;
                            if (!this.items?.data[key]?.reserveCooldown) {
                                if (this.items.data[key]) {
                                    this.items.data[key] = [];
                                    this.items.data[key].push({reserveCooldown: null});
                                }
                            }
                            this.items.data[key].reserveCooldown = hoursToShow + ':' + minutesToShow + ':' + secondsToShow;
                        }
                    }, 1000));
                }
            } else if (!iten.permanences_active[0] || iten.permanences_active[0] && !iten.permanences_active[0].finish) {
                this.items.data[key].reserveCooldown = '?';
            }
        },
        async setConfirmModal(reserve, realtor_name) {
            this.$store.commit('changeLoading', true);
            this.isDataRequired = null;
            this.isEmailRequired = null;
            this.isConfirm = true;
            this.isHistoric = false;
            this.modalTitle = 'RESERVE.CONFIRM_RESERVE';
            if (reserve.properties?.allotment_id) {
                Allotments.show(reserve.properties.allotment_id).then(resp => {
                    this.isDataRequired = resp.data.is_required_data_client;
                    this.isEmailRequired = resp.data.is_required_email;
                });
            }
            await Reserve.show(reserve.id).then(resp => {
                this.reserveIndex = resp.data;
                this.reserveIndex.realtor_name = realtor_name;
                this.wichModal = 2;
            }).finally(() => this.$store.commit('changeLoading', false));
        },
        async setEditModal(reserve, realtor_name) {
            this.$store.commit('changeLoading', true);
            this.isDataRequired = null;
            this.isEmailRequired = null;
            this.isConfirm = true;
            this.isHistoric = false;
            this.modalTitle = 'RESERVE.EDIT_RESERVE';
            this.wichModal = 8;
            Allotments.show(reserve.properties.allotment_id).then(resp => {
                this.isDataRequired = resp.data.is_required_data_client;
                this.isEmailRequired = resp.data.is_required_email;
            });
            await Reserve.show(reserve.id).then(resp => {
                resp?.data?.reserves_clients?.forEach(rc => {
                    if (rc?.clients?.id && !rc?.clients?.phones?.length) {
                        rc.clients.phones = [{code_country: 55, number: '', country_acronym: 'BR'}];
                    }
                })
                this.reserveIndex = resp.data;
                this.reserveIndex.realtor_name = realtor_name;
                this.$store.commit('changeLoading', false);
            }).finally(() => this.$store.commit('changeLoading', false));
        },
        setDropModal(reserve, realtor) {
            this.wichModal = 3;
            this.isConfirm = false;
            this.isHistoric = false;
            this.reserveIndex = reserve;
            this.reserveIndex.realtor = realtor;
            this.modalTitle = 'RESERVE.MSG.REALLY_WHANT_DROP_THIS_RESERVE';
        },
        setHistoricModal(reserve, realtor) {
            this.wichModal = 4;
            this.isHistoric = true;
            this.isConfirm = false;
            this.reserveIndex = reserve;
            this.reserveIndex.realtor = realtor;
            this.modalTitle = 'ACTIONS.INFO';
            this.$store.commit('changeLoading', true);
        },
        async setFilterModal() {
            this.$store.commit('changeLoading', true);
            this.wichModal = 5;
            this.modalTitle = 'ACTIONS.FILTER';
            this.$store.commit('changeLoading', false);
        },
        async updateAfterSearch(reserve, filter, id) {
            this.wichModal = null;
            this.isDataRequired = null;
            this.isEmailRequired = null;
            this.allotmentId = id;
            this.filter = filter;
            this.items = reserve.data;
            this.loopReserve.forEach(loop => clearInterval(loop));
            this.lotSort = 0;
            this.durationSort = 0;
            if (reserve.data?.data) {
                await this.indexRealtor(this.allotmentId);
                this.startAfterReseve(reserve.data?.data);
            }
        },
        async startAfterReseve(reserves) {
            if (reserves) {
                await reserves.forEach((reserve, key) => {
                    this.indexClients(reserve);
                    this.indexDuration(reserve, key);
                    if (this.realtors) {
                        this.realtorIndex[key] = this.realtors.find(r => r.id == reserve.realtor_id)?.text;
                    }
                });
            }
            this.$store.commit('changeLoading', false);
        },
        renew(reserve_id, allotment_id = null) {
            this.$store.commit('changeLoading', true);
            Reserve.renew(reserve_id, allotment_id).then(() => {
                this.loopReserve.forEach(loop => clearInterval(loop));
                this.indexReserve(this.allotmentId);
            }).catch(error => this.errorMsg(error))
                    .finally(() => this.$store.commit('changeLoading', false));
        },
        undetermined(reserve_id, allotment_id) {
            this.$store.commit('changeLoading', true);
            Reserve.undetermined(reserve_id, allotment_id).then(() => {
                this.loopReserve.forEach(loop => clearInterval(loop));
                this.indexReserve(this.allotmentId);
            }).catch(error => this.errorMsg(error))
                    .finally(() => this.$store.commit('changeLoading', false));
        },
        updateAfter() {
            this.$store.commit('changeLoading', true);
            this.loopReserve.forEach(loop => clearInterval(loop));
            this.indexReserve(this.allotmentId);
            this.$store.commit('changeLoading', false);
        },
        sort(items, howSorting) {
            if (items && !items.validations) {
                this.$store.commit('changeLoading', true);
                let filter = {sort: null, name: null};
                if (this.howSorting && this.howSorting.id == howSorting) {
                    this.howSorting.type == 1 ? this.howSorting.type-- : this.howSorting.type++;
                    filter.sort = this.howSorting.type;
                } else {
                    this.howSorting = {
                        type: 0,
                        id: howSorting,
                    };
                }
                this.loopReserve.forEach(loop => clearInterval(loop));
                Reserve.index(filter, this.allotmentId, 1, this.perPage).then(resp => {
                    this.items = resp.data;
                    this.startAfterReseve(resp.data?.data);
                });
                this.$store.commit('changeLoading', false);
            }
        },
        sortIcon(howId) {
            if (this.howSorting && this.howSorting.id == howId) {
                return this.howSorting.type == 1 ? 'arrow_upward' : 'arrow_downward';
            } else {
                return 'swap_vert';
            }
        },
    },
};
</script>
<style>
.size {
    font-size: 160%;
}

.size-red {
    font-size: 160%;
    width: 20px !important;
}

.red {
    color: #BF0505;
}

.green {
    color: #0e5e4e;
}

.zIndex {
    z-index: 100000000000 !important;
}

.paddin {
    padding-left: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.5rem;
}

.task-list .task-block .dropdown-menu:before {
    border-bottom: 0px solid #262b31 !important;
}

.reserve-header {
    display: flex;
    flex-wrap: wrap;
    align-items: self-end;
}

.aling {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.pd-top-left-right {
    padding-top: 0.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}

.pdt-1 {
    padding-top: 1rem;
}

.dropdown-reserve {
    width: 175px;
    left: 10% !important;
}

.reserve-client-list {
    max-width: 260px;
    min-width: 210px;
    overflow: hidden;
    text-overflow: initial;
    white-space: normal;
    word-break: break-word;
}

.reserve-proposals-cell {
    min-width: 104px;
    position: relative;
}

.reserve-proposals-wrapper {
    display: inline-flex;
    justify-content: center;
    padding: 2px 0;
    position: relative;
}

.reserve-proposals-wrapper:after {
    bottom: -16px;
    content: '';
    height: 18px;
    left: -34px;
    position: absolute;
    width: 140px;
}

.reserve-proposals-wrapper:before {
    content: '';
    height: 18px;
    left: -34px;
    position: absolute;
    top: -16px;
    width: 140px;
}

.reserve-proposals-trigger {
    align-items: center;
    background: #eef7f4;
    border: 1px solid #d6e9e2;
    border-radius: 999px;
    box-shadow: none;
    color: #0e5e4e;
    cursor: pointer;
    display: inline-flex;
    font-size: 13px;
    font-weight: 800;
    justify-content: center;
    line-height: 1;
    min-height: 28px;
    min-width: 28px;
    padding: 6px 9px;
    position: relative;
    transition: border-color .18s ease, box-shadow .18s ease, transform .18s ease;
}

.reserve-proposals-trigger:hover,
.reserve-proposals-trigger:focus {
    background: #e6f3ef;
    border-color: #afd5c8;
    box-shadow: none;
    outline: none;
    transform: translateY(-1px);
}

.reserve-proposals-trigger--empty {
    background: #fbfbfb;
    border-color: #e6e9e8;
    color: #9a9a9a;
}

.reserve-proposals-popover {
    background: #f7faf9;
    border: 1px solid #e2ece8;
    border-radius: 18px;
    box-shadow: 0 24px 55px rgba(15, 39, 54, .20), 0 8px 18px rgba(15, 39, 54, .10);
    max-width: calc(100vw - 24px);
    overflow: hidden;
    position: fixed;
    transform: translateX(-50%);
    z-index: 100000000001;
}

.reserve-proposals-popover:before {
    background: #0e5e4e;
    border-left: 1px solid #e2ece8;
    border-top: 1px solid #e2ece8;
    content: '';
    height: 14px;
    left: 50%;
    position: absolute;
    top: -6px;
    transform: translateX(-50%) rotate(45deg);
    width: 14px;
}

.reserve-proposals-popover--top {
    top: auto;
}

.reserve-status-badge {
    align-items: center;
    border-radius: 999px;
    display: inline-flex;
    font-size: 0.72rem;
    font-weight: 700;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    min-width: 96px;
    padding: 0.36rem 0.66rem;
    white-space: nowrap;
}

.reserve-status-badge--progress {
    background: #fff7ed;
    color: #c2410c;
}

.reserve-status-badge--canceled {
    background: #fef2f2;
    color: #b91c1c;
}

.reserve-status-badge--interrupted {
    background: #eff6ff;
    color: #1d4ed8;
}

.reserve-status-badge--confirmed {
    background: #f0fdf4;
    color: #166534;
}

.reserve-status-badge--expired {
    background: #f8fafc;
    color: #475569;
}

.reserve-status-badge--sale-canceled {
    background: #fff1f2;
    color: #be123c;
}

.reserve-status-badge--default {
    background: #f0fdfa;
    color: #0e5e4e;
}

.reserve-property-badge {
    color: inherit !important;
}

html.dark-theme .reserve-property-badge {
    color: inherit !important;
}

.reserve-proposals-popover--top:before {
    border-bottom: 1px solid #e2ece8;
    border-left: 0;
    border-right: 1px solid #e2ece8;
    border-top: 0;
    bottom: -6px;
    top: auto;
}

.reserve-proposals-popover__header {
    align-items: center;
    background: linear-gradient(135deg, #0e5e4e 0%, #137461 100%);
    border-bottom: 1px solid rgba(255, 255, 255, .08);
    color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 11px 14px 10px;
    position: relative;
}

.reserve-proposals-popover__header:before {
    background: rgba(255, 255, 255, .72);
    border-radius: 999px;
    content: '';
    height: 3px;
    left: 18px;
    position: absolute;
    top: 0;
    width: 54px;
}

.reserve-proposals-popover__header strong,
.reserve-proposals-popover__header small {
    display: block;
}

.reserve-proposals-popover__header strong {
    font-size: 14px;
    line-height: 1.2;
}

.reserve-proposals-popover__header small {
    color: rgba(255, 255, 255, .76);
    font-size: 11px;
    margin-top: 2px;
}

.reserve-proposals-popover__badge {
    background: rgba(255, 255, 255, .12);
    border: 1px solid rgba(255, 255, 255, .22);
    border-radius: 999px;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .04em;
    padding: 4px 9px;
    text-transform: uppercase;
}

.reserve-proposals-popover__body {
    background: #f7faf9;
    padding: 10px;
}

.reserve-proposals-loading {
    align-items: center;
    color: #0e5e4e;
    display: flex;
    font-size: 13px;
    font-weight: 700;
    gap: 8px;
    justify-content: center;
}

.reserve-proposals-list {
    display: flex;
    flex-direction: column;
    gap: 7px;
    max-height: var(--reserve-proposals-list-max-height, 320px);
    overflow-y: auto;
    padding: 2px 4px 2px 2px;
    scrollbar-color: #b9d2ca #edf4f1;
    scrollbar-width: thin;
}

.reserve-proposals-list::-webkit-scrollbar {
    width: 8px;
}

.reserve-proposals-list::-webkit-scrollbar-track {
    background: #edf4f1;
    border-radius: 999px;
}

.reserve-proposals-list::-webkit-scrollbar-thumb {
    background: #b9d2ca;
    border-radius: 999px;
}

.reserve-proposal-card {
    background: #fff;
    border: 1px solid #e4eeea;
    border-radius: 12px;
    box-shadow: 0 5px 14px rgba(15, 39, 54, .05);
    padding: 8px 10px;
    text-align: left;
    transition: border-color .18s ease, box-shadow .18s ease, transform .18s ease;
}

.reserve-proposal-card:hover {
    border-color: #c8ddd6;
    box-shadow: 0 12px 26px rgba(15, 39, 54, .10);
    transform: translateY(-1px);
}

.reserve-proposal-card__top {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
}

.reserve-proposal-card__number {
    color: #263238;
    font-size: 13px;
    font-weight: 700;
}

.reserve-proposal-card__status {
    border-radius: 999px;
    font-size: 10px;
    font-weight: 700;
    padding: 3px 8px;
}

.reserve-proposal-card__status--approved {
    background: #dff4e8;
    color: #137846;
}

.reserve-proposal-card__status--rejected {
    background: #fde6e6;
    color: #b42318;
}

.reserve-proposal-card__status--review {
    background: #fff4d8;
    color: #9a6700;
}

.reserve-proposal-card__info {
    background: #f8fbfa;
    border-radius: 9px;
    display: grid;
    gap: 6px;
    grid-template-columns: 1fr 1fr;
    padding: 7px 8px;
}

.reserve-proposal-card__detail {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.reserve-proposal-card__label {
    color: #8a949e;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: .04em;
    margin-bottom: 1px;
    text-transform: uppercase;
}

.reserve-proposal-card__detail strong {
    color: #344047;
    font-size: 11px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.reserve-proposals-empty {
    background: #fff;
    color: #7b8790;
    font-size: 13px;
    padding: 14px;
    text-align: center;
}

html.dark-theme .reserve-proposals-popover {
    background: var(--dark-surface-2);
    border-color: var(--dark-border);
    box-shadow: var(--dark-shadow-strong);
}

html.dark-theme .reserve-status-badge--progress {
    background: rgba(249, 115, 22, .11) !important;
    color: #fdba74 !important;
}

html.dark-theme .reserve-status-badge--canceled {
    background: rgba(239, 68, 68, .11) !important;
    color: #fca5a5 !important;
}

html.dark-theme .reserve-status-badge--interrupted {
    background: rgba(59, 130, 246, .11) !important;
    color: #93c5fd !important;
}

html.dark-theme .reserve-status-badge--confirmed {
    background: rgba(34, 197, 94, .11) !important;
    color: #86efac !important;
}

html.dark-theme .reserve-status-badge--expired {
    background: rgba(148, 163, 184, .10) !important;
    color: #cbd5e1 !important;
}

html.dark-theme .reserve-status-badge--sale-canceled {
    background: rgba(244, 63, 94, .11) !important;
    color: #fda4af !important;
}

html.dark-theme .reserve-status-badge--default {
    background: rgba(20, 184, 166, .10) !important;
    color: var(--dark-primary) !important;
}

html.dark-theme .reserve-proposals-trigger {
    background: rgba(20, 184, 166, .14);
    border-color: rgba(20, 184, 166, .26);
    box-shadow: none;
    color: var(--dark-primary);
}

html.dark-theme .reserve-proposals-trigger:hover,
html.dark-theme .reserve-proposals-trigger:focus {
    background: var(--dark-surface-2);
    border-color: rgba(20, 184, 166, .42);
    box-shadow: none;
}

html.dark-theme .reserve-proposals-trigger--empty {
    background: var(--dark-surface);
    border-color: var(--dark-border);
    color: var(--dark-text-muted);
}

html.dark-theme .reserve-proposals-popover:before {
    background: #0f766e;
    border-color: var(--dark-border);
}

html.dark-theme .reserve-proposals-popover__header {
    background: linear-gradient(135deg, #0f766e 0%, #115e59 100%);
    border-bottom-color: rgba(148, 163, 184, .18);
    color: var(--dark-text);
}

html.dark-theme .reserve-proposals-popover__header small {
    color: rgba(226, 232, 240, .78);
}

html.dark-theme .reserve-proposals-popover__badge {
    background: rgba(15, 23, 42, .24);
    border-color: rgba(226, 232, 240, .22);
    color: var(--dark-text);
}

html.dark-theme .reserve-proposals-popover__body,
html.dark-theme .reserve-proposals-empty {
    background: var(--dark-surface-2);
}

html.dark-theme .reserve-proposals-loading {
    color: var(--dark-primary);
}

html.dark-theme .reserve-proposals-list {
    scrollbar-color: rgba(20, 184, 166, .38) rgba(15, 23, 42, .72);
}

html.dark-theme .reserve-proposals-list::-webkit-scrollbar-track {
    background: rgba(15, 23, 42, .72);
}

html.dark-theme .reserve-proposals-list::-webkit-scrollbar-thumb {
    background: rgba(20, 184, 166, .38);
}

html.dark-theme .reserve-proposal-card {
    background: var(--dark-surface);
    border-color: var(--dark-border);
    box-shadow: 0 8px 22px rgba(2, 6, 23, .22);
}

html.dark-theme .reserve-proposal-card:hover {
    border-color: var(--dark-border-strong);
    box-shadow: 0 12px 28px rgba(2, 6, 23, .34);
}

html.dark-theme .reserve-proposal-card__number {
    color: var(--dark-text);
}

html.dark-theme .reserve-proposal-card__info {
    background: rgba(30, 41, 59, .72);
}

html.dark-theme .reserve-proposal-card__label {
    color: var(--dark-text-muted);
}

html.dark-theme .reserve-proposal-card__detail strong {
    color: var(--dark-text-soft);
}

html.dark-theme .reserve-proposals-empty {
    color: var(--dark-text-muted);
}

@media screen and (max-width: 575px) {
    .reserve-proposal-card__info {
        grid-template-columns: 1fr;
    }

    .pd-top-left-right {
        padding-top: 1rem;
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .page-header {
        padding: 0rem;
    }

    .dropdown-reserve {
        left: 3% !important;
    }
}
</style>
